<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1270px"
      unit="商品信息"
      title="商品信息"
      id-key="RecordId"
      :data="data"
      form-label-width="130px"
      
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="box-header">基础信息</div>
        <div class="box">
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品名称" prop="GoodsName">
                {{data.GoodsName}}
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品编码" prop="GoodsCode">
                {{data.GoodsCode}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="平台分类" prop="TypeplatformId">
               {{data.TypeplatformName}}
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商家分类">
                <span>{{ data.TypeName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品单位" prop="MainUnitName">
                {{data.MainUnitName}}
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品品牌" prop="BrandName">
                {{data.BrandName}}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="isMB?24:12">
              <el-form-item label="贸易模式" prop="TradeMode">
                <el-select v-model="data.TradeMode" placeholder="请选择贸易模式" clearable>
                  <el-option label="跨境进口" :value="0"></el-option>
                  <el-option label="一般贸易" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="所属平台首页标签" prop="LabelName">
                {{data.LabelName}}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- <el-col :span="isMB ? 24 : 12">
              <el-form-item label="序号" prop="OrderId">
                {{data.OrderId}}
              </el-form-item>
            </el-col> -->

            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="状态" prop="State">
                <span v-if="data.State==1">正常</span>
                <span v-else>停用</span>
                <!-- <el-radio-group v-model="data.State">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        
        <div class="box-header">
          <span>规格型号明细</span>
         
        </div>
      
        <el-table
          ref="attributes"
          :data="data.Attributes"
          highlight-current-row
          border
          style="width: 100%"
          v-if="data.Attributes.length > 0"
        >
          <el-table-column prop="OrderId" label="序号" width="80"> </el-table-column>
          <el-table-column
            prop="AttributeName"
            label="规格型号"
          >
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
         <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import goodsSelect from "@/components/goods/infobonded/select";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    goodsSelect,
    treeSelect,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: null, //序号
        BarCode: "", //条码
        QrCode: "", //二维码
        GoodsCode: "", //编码
        GoodsName: "", //名称
        TypeId: null, //分类
        TypeName: "",
        TypeNameChain: "", //分类名称链
        IfShelflife: 0,
        BrandId: null, //品牌
        TradeMode: 0, //贸易模式 0跨境进口，1一般贸易
        GoodsModel: "", //规格型号
        MainUnitid: null, //主单位
        AuxiliaryUnitid: null, //辅单位
        DistributionPrice: null,
        OriginalPrice: null,
        PlatformPrice: null,
        GoodsRemark: "", //备注
        sale_range: "",
        return_illustrate: "",
        State: 1, //状态 - 0：停用，1：正常
        Attributes: [], //属性
        Labeldetails: [], //标签,必须与后端得映射的名称定义相同
        TypeplatformId: null, //平台分类
        GroupDtos: [], //属性组
        LabelId:null,
        LabelName:"",
        MainUnitName:"",
        TypeplatformName:"",
        BrandName:""
      },
      DelAttributes: [], //将要删除的属性
      SelectAttributes: [], //选中的属性

      selectinfobondedgoods: [], //选中备案商品数组
      infobondedgoodsApi: require("@/api/goods/infobonded").default, //获取可选备案商品的接口
      LabelList: [],
      place: [],
      arr2: [],
      api: require("@/api/goods/info").default,
      brand_api: require("@/api/goods/brand").default,
      unit_api: require("@/api/goods/unit").default,
      typePlatform_api: require("@/api/goods/typeplatform").default,
      spec_api: require("@/api/goods/spec").default,
      label_api: require("@/api/mall/label").default,

      isMB: this.$store.state.isMB,
      rules: {
        GoodsCode: [{ required: true, message: "商品编码不能为空" }],
        GoodsName: [{ required: true, message: "商品名称不能为空" }],
        // DistributionPrice: [{ required: true, message: "分销价不能为空" }],
        // OriginalPrice: [{ required: true, message: "销售指导价不能为空" }],
        // PlatformPrice: [{ required: true, message: "市场价不能为空" }],
        // BrandId: [{ required: true, message: "品牌不能为空" }],
        MainUnitid: [{ required: true, message: "商品单位不能为空" }],
        TypeplatformId: [{ required: true, message: "平台分类不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      infobondedgoods: [], //备案商品列表
      initinfobondedgoods: [],
      Brands: [],
      Units: [],
      TypePlatforms: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
      Specs: [],
    };
  },
  mounted() {
    this.unit_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Units = res.Data;
      }
    }),
      this.brand_api.list({ State: 1 }).then((res) => {
        if (res.Code == 0) {
          this.Brands = res.Data;
        }
      });
    this.typePlatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
    this.spec_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Specs = res.Data;
      }
    });
    this.label_api.list({ DataType: 1 }).then((res) => {
      if (res.Code == 0) {
        this.LabelList = res.Data;
      }
    });
  },
  methods: {
    onTreeSelect(t) {
      if (!t) {
        this.data.TypeplatformName = "";
        this.data.TypeplatformId = null;
      } else {
        this.data.TypeplatformName = t.TypepName;
        this.data.TypeplatformId = t.RecordId;
      }
    },
    onOpened() {
      console.log("aa");
      this.infobondedgoodsApi
        .list({ FilingsState: 1, pageIndex: 1, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.initinfobondedgoods = this.infobondedgoods = res.Data; //调用接口，把结果赋值给infobondedgoods 数组，就是显示可选商品和规格
            this.initTotal = this.listTotal = res.Count;
          }
        });
    },
    onCreateOpened() {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      }),
        this.addAttribute();
    },
    getOption() {
      // this.loading(true);  //打开加载效果
      // this.lable_api.list({ State: 1 }).then(res => {
      //   if (res.Code == 0) {
      //     this.labelList = res.Data;
      //   }
      // });

      //名称链转为数组
      var typeNames = this.data.TypeNameChain.split(".");
      //获取第一个
      var typeName = typeNames.length > 0 ? typeNames[0] : "";
      console.log("getOption", typeName, this.data.TypeNameChain);

      /* this.brand_api.list({ State: 1, TypeName: typeName }).then(res => {
        if (res.Code == 0) {
          this.Brands = res.Data;
        }
      })*/
      //加载备案商品
      this.onOpened();
    },
    onEditOpened(data) {
      console.log(data, "data");
      
    console.log(this.$refs,"refs");
    this.$refs.treeSelect.setData();
      this.data.Attributes = data.Attributes.map((x, i) => {
        return { ...x, Index: i, T: 3 };
      });
      this.data.GroupDtos = data.GroupDtos.map((x, i) => {
        return { ...x, Index: i, T: 3 };
      });
      this.getOption();

      var arr = [];
      for (let i = 0; i < this.arr2.length; i++) {
        const e = this.arr2[i];
        if (i == 0) arr.push(e);
        else {
          for (let j = 0; j < arr.length; j++) {
            const n = arr[j];
            if (n > e) {
              arr.splice(j, 0, e);
              break;
            }
            if (j == arr.length - 1) {
              arr.push(e);
              break;
            }
          }
        }
      }
      this.arr2 = arr;

      console.log("data", this.data);
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.infobondedgoods = this.initinfobondedgoods;
      this.listTotal = this.initTotal;
    },
    currentPage(data, row) {
      this.pageParams.pageIndex = data.val;
      this.infobondedgoodsApi
        .list({
          FilingsState: 1,
          pageIndex: data.val,
          pageSize: 7,
          FilingsName: row.FilingsName,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.infobondedgoods = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text, row) {
      row.GoodsName = text;
      this.infobondedgoodsApi
        .list({ Status: 1, pageIndex: 1, pageSize: 7, FilingsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.infobondedgoods = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    onSetGoods(e, row) {
      console.log("商品", JSON.parse(JSON.stringify(e)));
      console.log("明细", JSON.parse(JSON.stringify(row)));

      /* if (this.data.Goods.some(x => x.GoodsId == e.GoodsId && x.AttributeId == e.RecordId)) {
        this.$message.warning("已存在商品和商品属性相同的明细");
        return;
      }  */

      if (row.T !== 0) row.T = 1; //判断这条数据是否新增的，T==0就是新增的，不是0就需要改成1，因为T==1是修改。

      row.FilingsOrderid = e.FilingsOrderid;
      row.FilingsName = e.FilingsName;
    },

    onInput(row, type) {
      if (row.T !== 0) row.T = 1;

      if (row.InPrice) {
        var inPriceStr = row.InPrice.toString();
        row.InPrice = inPriceStr.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      }

      var inCount = parseFloat(row.InCount);
      var inPrice = parseFloat(row.InPrice);
      if (!Number.isNaN(inCount) && !Number.isNaN(inPrice)) {
        row.InAmount = parseFloat((inCount * inPrice).toFixed(2));
      } else {
        row.InAmount = null;
      }
    },
    onSelectGoods(selection) {
      this.selectinfobondedgoods = selection;
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      data = this.$commonJs.obj.removeNullKey(data);

      var to = [];
      /*   var arr2 = this.arr2;
      var place = this.place;
      place.forEach(e => {
        if (arr2.indexOf(e.LabelId) == -1) {
          to.push({ ...e, T: 2 });
        }
      })
      arr2.forEach(e => {
        var obj = place.find(x => x.LabelId == e);
        if (!obj) {
          to.push({ T: 0, GoodsId: this.data.RecordId, RecordId: 0, LabelId: e })
        }
      })
      data.Labeldetails = to;  */ //这句话就是把标签选中的id传给参数中的Labeldetails，然后去调用后端接口传这个数据进去

      if (this.data.GroupDtos.length == 0) {
        this.$message.warning("请添加商品规格");
        return false;
      }

      if (this.data.GroupDtos.some((x) => !x.AttributeName)) {
        this.$message.warning("规格名称不能为空");
        return false;
      }

      if (this.data.GroupDtos.some((x) => !x.GroupName)) {
        this.$message.warning("规格组名不能为空");
        return false;
      }

      data.GroupDtos = this.data.GroupDtos.filter((x) => x.T != null);

      this.DelAttributes.forEach((x) => data.GroupDtos.push(x));

      console.log("save", data);

      // return false
      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.GroupDtos = [];
      this.DelAttributes = [];
      this.SelectAttributes = [];
    },
    selectAttribute(selection) {
      this.SelectAttributes = selection;
    },
    setEdit(data, attribute = null) {
      if (data.T != 0) data.T = 1;
    },
    //添加属性
    addAttribute() {
      var orders = this.data.GroupDtos.map((x) => x.OrderId).sort((a, b) => {
        return b - a;
      });
      this.data.GroupDtos.push({
        Index: this.data.GroupDtos.length,
        RecordId: 0,
        OrderId: orders.length == 0 ? 0 : orders[0] + 1,
        GoodsId: this.data.RecordId, //商品
        AttributeName: "", //属性名称
        GroupName: "",
        T: 0,
      });
    },
    //删除属性
    delAttribute() {
      if (this.SelectAttributes.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.SelectAttributes.forEach((x) => {
        if (x.T != 0) {
          this.DelAttributes.push({ ...x, T: 2 });
        }
        this.data.GroupDtos.splice(x.Index, 1);
      });
      //清空选中的数据
      this.SelectAttributes = [];
      //对序号进行重新排序
      this.data.GroupDtos.forEach((x, i) => (x.Index = i));
    },

    onClosed() {
      this.selectinfobondedgoods = [];
      this.DelAttributes = [];
      this.data.GroupDtos = [];
    },
    ////添加属性值
    // addAttributeValue(attribute) {
    //   // console.log("addAttributeValue", attribute)
    //   var orders = attribute.AttributeValues.map(x => x.OrderId).sort((a, b) => { return b - a });
    //   attribute.AttributeValues.push({
    //     RecordId: 0,
    //     OrderId: orders.length == 0 ? 0 : orders[0] + 1,
    //     GoodsId: this.data.RecordId, //商品
    //     AttributeId: attribute.RecordId, //属性
    //     AttributeValue: "", //属性值
    //     T: 0,
    //   })
    // },
    ////删除属性值
    // delAttributeValue(attribute, index) {
    //   var row = attribute.AttributeValues[index];
    //   if (row.T != 0) {
    //     attribute.T = 1;
    //     attribute.DelAttributeValues.push({ ...row, T: 2 })
    //   }
    //   attribute.AttributeValues.splice(index, 1);
    // }
  },
};
</script>